/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which formula is used?`)
};

const es_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué fórmula se usa?`)
};

const de_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Formel wird verwendet?`)
};

const nl_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke formule wordt gebruikt?`)
};

const fr_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle formule est utilisée ?`)
};

const it_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale formula viene usata?`)
};

const pt_br2_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual fórmula é usada?`)
};

const pt_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que fórmula é usada?`)
};

const ja_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの計算式が使われていますか?`)
};

const zh_bmr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的是哪个公式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_faq_q3", locale)
	if (locale === "en") return en_bmr_faq_q3(inputs)
	if (locale === "es") return es_bmr_faq_q3(inputs)
	if (locale === "de") return de_bmr_faq_q3(inputs)
	if (locale === "nl") return nl_bmr_faq_q3(inputs)
	if (locale === "fr") return fr_bmr_faq_q3(inputs)
	if (locale === "it") return it_bmr_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_faq_q3(inputs)
	if (locale === "pt") return pt_bmr_faq_q3(inputs)
	if (locale === "ja") return ja_bmr_faq_q3(inputs)
	return zh_bmr_faq_q3(inputs)
};